export default __webpack_public_path__ + "static/media/cover-kids.13112fdb.png";